import { render, staticRenderFns } from "./AutoChatAssign.vue?vue&type=template&id=02674c1d&scoped=true"
import script from "./AutoChatAssign.vue?vue&type=script&lang=js"
export * from "./AutoChatAssign.vue?vue&type=script&lang=js"
import style0 from "./AutoChatAssign.vue?vue&type=style&index=0&id=02674c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02674c1d",
  null
  
)

export default component.exports